/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * Сервис реализует функционал управления операциями с устройствами
 */

/**
 * Сервис устройств
 */
export class CommandDeviceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод отправки задания на открытие устройства.
   * Метод доступен для: admin, service
   */
  PostCommandDeviceOpen = (req: PostCommandDeviceOpenRequestDto, init?: RequestInit): Promise<PostCommandDeviceOpenResponseDto> => {
    return fm.request<PostCommandDeviceOpenRequestDto, PostCommandDeviceOpenResponseDto>(`${this.host}/device/api/v1/command/device/${encodeURIComponent(req.deviceId)}/open`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на отправку задания на открытие устройства
 */
export type PostCommandDeviceOpenRequestDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Ответ на запрос на отправку задания на открытие устройства
 */
export type PostCommandDeviceOpenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostCommandDeviceOpenResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostCommandDeviceOpenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostCommandDeviceOpenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на отправку задания на открытие устройства
   */
  "PostCommandDeviceOpenRequest": {
    "kind": "class",
    "text": "Запрос на отправку задания на открытие устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на отправку задания на открытие устройства
   */
  "PostCommandDeviceOpenResponse": {
    "kind": "class",
    "text": "Ответ на запрос на отправку задания на открытие устройства",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostCommandDeviceOpenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostCommandDeviceOpenResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}